module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/directions.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/directions.jpg
// module id = 32
// module chunks = 0